import React, { useEffect, useState } from "react";
import { useLang } from "../../contexts/LanguageContext";
import { api } from "../../lib/api";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";

export default function AdminFamilies() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/families").then(r => setItems(r.data)); }, []);

  return (
    <div data-testid="admin-families">
      <p className="overline mb-1">OFA France · Admin</p>
      <h1 className="font-serif text-3xl tracking-tight mb-6">{t("admin.families")}</h1>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/50 text-xs uppercase tracking-wider text-muted-foreground">
              <tr><th className="p-3 text-left">Parent</th><th className="p-3 text-left">Email</th><th className="p-3 text-left">Country</th><th className="p-3 text-left">Lang</th><th className="p-3 text-left">Children</th></tr>
            </thead>
            <tbody>
              {items.map(f => (
                <tr key={f.id} data-testid={`family-row-${f.id}`} className="border-t border-border">
                  <td className="p-3 font-medium">{f.parent_first_name} {f.parent_last_name}</td>
                  <td className="p-3 text-xs">{f.email}</td>
                  <td className="p-3 text-xs">{f.country}</td>
                  <td className="p-3 text-xs uppercase">{f.language}</td>
                  <td className="p-3"><div className="flex flex-wrap gap-1">{f.students?.map(s => <Badge key={s.id} variant="outline">{s.first_name} ({s.grade || '—'})</Badge>)}</div></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-muted-foreground">No families</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
